// Links inside hub article HTML point back into the hub as
// {KB_BASE_URL}/learn/<market>/<slug>; everything else is external.
export type KbLearnHref = {
  market: string;
  slug: string;
};

export const parseKbLearnHref = (
  href: string,
  kbBaseUrl: string,
): KbLearnHref | null => {
  const prefix = `${kbBaseUrl}/learn/`;

  if (!href.startsWith(prefix)) return null;

  const path = href.slice(prefix.length).split('?')[0].split('#')[0];
  const parts = path.split('/').filter(Boolean);

  if (parts.length === 0) return null;

  return {
    market: parts[0],
    slug: parts.slice(1).join('/'),
  };
};
